import React from "react";
import PropTypes from "prop-types";
import "./DeleteCohortModel.scss";
import { Modal } from "react-bootstrap";
import exportimages from "../../../../assets/images/exportImages";
import { useDispatch } from "react-redux";
import { HttpStatusCode } from "axios";
import { useDeleteCohortMutation } from "../../../../rtk-query/features/cohort/cohortRTK";
import { setLoaderFalse, setLoaderTrue } from "../../../../Redux/loaderSlice";
import { setSelectedCohort } from "../../../../rtk-query/features/cohort/cohortSlice";

export const DeleteCohortModel = ({ uid, onHide, ...rest }) => {
  const dispatch = useDispatch();
  const [deleteCohort] = useDeleteCohortMutation();

  const handleDeleteCohort = async () => {
    dispatch(setLoaderTrue());
    const response = await deleteCohort({ cohortId: uid });
    if (response?.data?.statusCode === HttpStatusCode.Ok) {
      onHide();
    }
    dispatch(setSelectedCohort(null));
    dispatch(setLoaderFalse());
  };

  return (
    <Modal
      {...rest}
      onHide={onHide}
      animation
      aria-labelledby="contained-modal"
      centered
      width="400px"
    >
      <Modal.Body className="cohort-modal">
        <div className="create-cohort-modal">
          <div className="modal-header">
            <div className="icon-outer-circle">
              <div className="icon-inner-circle">
                <img alt="icon" src={exportimages.delete_cohort_icon} />
              </div>
            </div>
          </div>
          <h2>Delete Cohort</h2>
          <p className="subtitle">
            Are you sure you want to delete this cohort? This action cannot be
            undone.
          </p>
          <div className="actions">
            <button className="btn cancel" onClick={onHide}>
              Cancel
            </button>
            <button className="btn primary" onClick={handleDeleteCohort}>
              Delete
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

DeleteCohortModel.propTypes = {
  uid: PropTypes.string.isRequired,
  onHide: PropTypes.func.isRequired,
};
